<article class="feed-card-container cursor-pointer" role="button" tabindex="0"
    (click)="viewHires()" (keydown)="onCardKeydown($event)"
    [attr.aria-label]="'View hires'">

    <div class="flex w-full min-w-0 flex-row items-start justify-between gap-3">

        <div class="flex min-w-0 flex-1 items-center">
            <div class="shrink-0">
                <div
                    class="size-12 rounded-lg flex items-center justify-center bg-green-50 dark:bg-green-900/30 dark:pill-green-900/30">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-6 text-green-500" aria-hidden="true">
                        <path d="M12 12h.01" />
                        <path d="M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
                        <path d="M22 13a18.15 18.15 0 0 1-20 0" />
                        <rect width="20" height="14" x="2" y="6" rx="2" />
                    </svg>
                </div>
            </div>
            <div class="ml-3 min-w-0 flex-1">
                <div class="flex min-w-0 flex-wrap items-center gap-x-2">
                    <h3 class="truncate text-base font-semibold text-primary">{{ activity.briefApplications.length}} {{ activity.briefApplications.length > 1 ? "Creators" : "Creator" }} Hired!</h3>

                    @if (activity.briefProgressStatus == "AutoPilotHired") {
                    <span class="shrink-0 text-sm text-secondary italic">(Auto-Pilot)</span>
                    }
                </div>
                <p class="truncate text-sm text-secondary">
                    {{ activity.briefApplications.length }} {{ activity.briefApplications.length > 1 ? "creators" : "creator" }} have been hired for this brief.
                </p>
            </div>
        </div>

        <div class="flex shrink-0 flex-col items-end justify-start">
            <p class="text-sm text-secondary">
                {{ formatService.getTimeSinceUpdated(activity.date) }}
            </p>
        </div>
    </div>

    <div class="flex w-full min-w-0 flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div class="flex min-w-0 overflow-hidden">
            <div class="flex -space-x-1">
                <dt class="sr-only">Hires</dt>
                @for (application of activity.briefApplications.slice(0, 5); track application.id) {
                <dd class="relative size-10 shrink-0 text-green-500 rounded-full outline-2 outline-green-500">
                    <img [src]="imageService.getImageSource(application.creator.photoURL, 'gallery')" alt=""
                        class="size-10 rounded-full bg-gray-50 dark:bg-gray-800 dark:outline-gray-900" />
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                        class="z-10 size-4 absolute -bottom-1.5 -left-1.5" aria-hidden="true">
                        <path fill-rule="evenodd"
                            d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                            clip-rule="evenodd" />
                    </svg>
                </dd>
                }
                @if (activity.briefApplications.length > 5) {
                <dd
                    class="relative z-10 flex size-10 shrink-0 items-center justify-center rounded-full bg-green-100 text-xs font-semibold text-green-700 outline-2 outline-green-500 dark:bg-green-900/50 dark:text-green-200">
                    +{{ activity.briefApplications.length - 5 }}
                </dd>
                }
            </div>
        </div>

        <div class="shrink-0 self-start sm:self-auto">
            <span
                class="inline-flex items-center gap-x-1.5 rounded-full bg-green-600 px-2.5 py-1.5 text-sm text-white shadow-xs dark:bg-green-500 dark:shadow-none"
                aria-hidden="true">
                View Hires
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="-mr-0.5 size-5">
                    <path
                        d="M12.034 12.681a.498.498 0 0 1 .647-.647l9 3.5a.5.5 0 0 1-.033.943l-3.444 1.068a1 1 0 0 0-.66.66l-1.067 3.443a.5.5 0 0 1-.943.033z" />
                    <path d="M21 11V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6" />
                </svg>
            </span>
        </div>
    </div>

</article>
